module.exports = __webpack_public_path__ + "components/flag/static/square/ca-d168c1c5c399ce7fd20c8dace410340c.svg";